import { render, staticRenderFns } from "./ViewAssignedTaskModal.vue?vue&type=template&id=468b01fd&scoped=true"
import script from "./ViewAssignedTaskModal.vue?vue&type=script&lang=js"
export * from "./ViewAssignedTaskModal.vue?vue&type=script&lang=js"
import style0 from "./ViewAssignedTaskModal.vue?vue&type=style&index=0&id=468b01fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468b01fd",
  null
  
)

export default component.exports